import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class PeopleService extends ApiService {
  namespace = "type";
  icon = "BlueCube";
  name = "Type";
  favicon = "Bullets";
  window = 290;
  Width = 1100;
  DOMAIN = -43;
  action = "action";
  singular = this.terminology.type.singular;
  plural = this.terminology.type.plural;
  vowel = this.terminology.type.vowel;
  columns = [
    {
      header: this.t("displayName"),
      icon: "UserSilhouette",
      field: "display_name",
    },
    {
      header: "Primary Phone #",
      icon: "MobilePhone",
      field: "phone",
    },
    {
      header: "Alt.Phone #",
      icon: "MobilePhone",
      field: "number",
    },
    {
      header: "Since",
      icon: "MobilePhone",
      field: "since",
    },
    {
      header: this.t("number"),
      icon: "Shred",
      field: "number",
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit an Type",
      icon: PrimeIcons.PENCIL,
    },
  ];
  permissions = [
    {
      key: "employee",
      display_name: "Employees ",
      icon: "BlueSilhouette",
      value: 17,
    },
    {
      key: "domain",
      display_name: "Vendors",
      icon: "OrangeSilhouette",
      value: 18,
    },

    {
      key: "domain",
      display_name: "Other Contacts",
      icon: "YellowSilhouette",
      value: 148,
    },
    {
      key: "domain",
      display_name: "Users",
      icon: "GraySilhouette",
      value: 89,
    },
    {
      key: "domain",
      display_name: "Customers",
      icon: "GreenSilhouette",
      value: 34,
    },
    {
      key: "domain",
      display_name: "Prospects",
      icon: "GreenSilhouette",
      value: 203,
    },
    {
      key: "domain",
      display_name: "Private Contacts",
      icon: "UserSilhouette",
      value: 149,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Type",
      icon: PrimeIcons.LIST,
    },
  ];
  constructor() {
    super("employees");
  }
}
